import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Button, Label, Input, Table } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

function ComponentesKit() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  // Fallback derivado por si el .env todavia no trae la variable nueva
  const URL_COMPONENTES_KIT =
    process.env.REACT_APP_URL_COMPONENTES_KIT ||
    `${process.env.REACT_APP_URL_ARTICULOS}`.replace(
      /\/articulos\/?$/i,
      "/componentesKit"
    );
  // Las rutas de armado van al mismo nivel, no cuelgan del recurso
  const URL_ARMAR = `${URL_COMPONENTES_KIT}Armar`;
  const URL_DESARMAR = `${URL_COMPONENTES_KIT}Desarmar`;

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const [articulos, setArticulos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

  const [kit, setKit] = useState(null);
  const [componentes, setComponentes] = useState([]);
  const [disponible, setDisponible] = useState(null);

  const [cantidadKits, setCantidadKits] = useState(1);
  const [procesando, setProcesando] = useState(false);

  const [editarComponentes, setEditarComponentes] = useState(false);
  const [nuevoComponente, setNuevoComponente] = useState(null);
  const [nuevaCantidad, setNuevaCantidad] = useState(1);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, { headers })
      .then((res) => setArticulos(res.data || []))
      .catch((err) => console.log(err));
    axios
      .get(URL_AREAS, { headers })
      .then((res) => setAreas(res.data || []))
      .catch((err) => console.log(err));
  }, []);

  // El selector de arriba solo lista kits ya creados
  const opcionesKits = articulos
    .filter((a) => a.esKit === "Si")
    .map((a) => ({ ...a, junta: `${a.SKU || ""} ${a.nombre || ""}` }));

  // El de componentes lista todo
  const opciones = articulos.map((a) => ({
    ...a,
    junta: `${a.SKU || ""} ${a.nombre || ""}`,
  }));

  const refrescar = (kitId, area) => {
    if (!kitId) return;
    axios
      .get(`${URL_COMPONENTES_KIT}/kit/${kitId}`, { headers })
      .then((res) => setComponentes(res.data || []))
      .catch((err) => console.log(err));

    if (!area) {
      setDisponible(null);
      return;
    }
    axios
      .get(`${URL_COMPONENTES_KIT}/disponible/${kitId}/${area}`, { headers })
      .then((res) => setDisponible(res.data))
      .catch(() => setDisponible(null));
  };

  const seleccionaKit = (a) => {
    setKit(a);
    setComponentes([]);
    setDisponible(null);
    setEditarComponentes(false);
    if (a?._id) refrescar(a._id, selectedArea);
  };

  const armar = async (signo) => {
    if (!kit || !selectedArea) {
      Swal.fire({
        icon: "error",
        title: "Faltan datos",
        text: "Selecciona el kit y el almacén.",
      });
      return;
    }
    const cant = parseFloat(cantidadKits);
    if (!cant || cant <= 0) {
      Swal.fire({
        icon: "error",
        title: "Cantidad inválida",
        text: "La cantidad de kits debe ser mayor a 0.",
      });
      return;
    }
    if (componentes.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Sin componentes",
        text: "Este kit no tiene componentes dados de alta.",
      });
      return;
    }

    const detalle = componentes
      .map(
        (c) =>
          `<li><b>${c.componentes?.[0]?.SKU || "-"}</b>: ${
            parseFloat(c.cantidad) * cant
          }</li>`
      )
      .join("");

    const conf = await Swal.fire({
      title: signo > 0 ? `¿Armar ${cant} kits?` : `¿Desarmar ${cant} kits?`,
      html:
        (signo > 0
          ? "Se descontará del inventario:<br><ul>"
          : "Se regresará al inventario:<br><ul>") +
        detalle +
        `</ul>y ${signo > 0 ? "entrarán" : "saldrán"} <b>${cant}</b> de ${
          kit.SKU
        }`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: signo > 0 ? "Sí, armar" : "Sí, desarmar",
      cancelButtonText: "Cancelar",
    });
    if (!conf.isConfirmed) return;

    setProcesando(true);
    try {
      const { data } = await axios.post(
        signo > 0 ? URL_ARMAR : URL_DESARMAR,
        { articulos: kit._id, cantidad: cant, areas: selectedArea },
        { headers }
      );

      await axios.post(
        URL_LOGS,
        {
          tipo: signo > 0 ? "Armar Kit" : "Desarmar Kit",
          detalle: `${kit.SKU} x${cant} en ${selectedArea}`,
          user: user.id,
        },
        { headers }
      );

      Swal.fire({
        icon: "success",
        title: "Good job!",
        html: `${signo > 0 ? "Armados" : "Desarmados"} ${cant}. Ahora hay <b>${
          data.enInventario
        }</b> ${kit.SKU} en inventario.`,
      });
      refrescar(kit._id, selectedArea);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo completar la operación",
        footer: `${error.response?.data?.message || error.message || ""}`,
      });
    }
    setProcesando(false);
  };

  const agregarComponente = async () => {
    if (!kit || !nuevoComponente) return;
    if (parseFloat(nuevaCantidad) <= 0) {
      Swal.fire({
        icon: "error",
        title: "Cantidad inválida",
        text: "La cantidad debe ser mayor a 0.",
      });
      return;
    }
    try {
      await axios.post(
        URL_COMPONENTES_KIT,
        {
          articulos: kit._id,
          componentes: nuevoComponente._id,
          cantidad: parseFloat(nuevaCantidad),
        },
        { headers }
      );
      setNuevoComponente(null);
      setNuevaCantidad(1);
      refrescar(kit._id, selectedArea);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response?.data?.message || error.message || ""}`,
      });
    }
  };

  const eliminarComponente = async (id) => {
    const conf = await Swal.fire({
      title: "¿Quitar componente?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, quitar",
      cancelButtonText: "Cancelar",
    });
    if (!conf.isConfirmed) return;
    try {
      await axios.delete(`${URL_COMPONENTES_KIT}/${id}`, { headers });
      refrescar(kit._id, selectedArea);
    } catch (error) {
      Swal.fire({ icon: "error", title: "Oops...", text: "No se pudo quitar" });
    }
  };

  const cant = parseFloat(cantidadKits) || 0;
  const fmt = (v) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(v) || 0);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card container col-10">
          <h3 align="center">Armar Kits</h3>
          <p style={{ textAlign: "center", color: "#666" }}>
            Al armar se descuenta cada componente del inventario y el kit entra
            como artículo propio, listo para venderse. Las cantidades son en
            piezas: las piezas por caja no entran en el cálculo.
          </p>
          <Row>
            <Col md={3}>
              <Button color="success" href="/ArticulosKitCreate">
                <i className="fas fa-plus"></i> Nuevo Kit
              </Button>
            </Col>
          </Row>
          <br />

          <Row>
            <Col md={7}>
              <Label>Kit</Label>
              <Autocomplete
                size="small"
                value={kit}
                onChange={(event, sel) => seleccionaKit(sel)}
                options={opcionesKits}
                getOptionLabel={(option) => option.junta || ""}
                renderInput={(params) => (
                  <TextField {...params} label="Selecciona" variant="outlined" />
                )}
                renderOption={(option) => (
                  <React.Fragment>
                    {option.SKU} {option.nombre}
                  </React.Fragment>
                )}
              />
            </Col>
            <Col md={5}>
              <Label>Almacén</Label>
              <Input
                type="select"
                value={selectedArea}
                onChange={(e) => {
                  setSelectedArea(e.target.value);
                  refrescar(kit?._id, e.target.value);
                }}
              >
                <option value="">Selecciona un almacén</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => (
                    <option value={a._id} key={a._id}>
                      {a.name}
                    </option>
                  ))}
              </Input>
            </Col>
          </Row>

          {kit ? (
            <>
              <br />
              {disponible && disponible.esKit ? (
                <Row>
                  <Col md={6}>
                    <div
                      style={{
                        background: "#eff6ff",
                        border: "1px solid #bfdbfe",
                        borderRadius: 8,
                        padding: "8px 12px",
                        fontSize: "0.9rem",
                      }}
                    >
                      Ya armados en este almacén:{" "}
                      <b>{fmt(disponible.armados)}</b>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div
                      style={{
                        background: "#f0fdf4",
                        border: "1px solid #bbf7d0",
                        borderRadius: 8,
                        padding: "8px 12px",
                        fontSize: "0.9rem",
                      }}
                    >
                      Se pueden armar hasta <b>{disponible.cantidad}</b> más
                    </div>
                  </Col>
                </Row>
              ) : undefined}

              <br />
              <Row>
                <Col md={3}>
                  <Label>Cantidad de kits</Label>
                  <Input
                    type="number"
                    min="0"
                    step="any"
                    value={cantidadKits}
                    onChange={(e) => setCantidadKits(e.target.value)}
                  />
                </Col>
                <Col md={3}>
                  <Label>&nbsp;</Label>
                  <Button
                    color="success"
                    block
                    onClick={() => armar(1)}
                    disabled={procesando || !selectedArea}
                  >
                    <i className="fas fa-boxes"></i> Armar
                  </Button>
                </Col>
                <Col md={3}>
                  <Label>&nbsp;</Label>
                  <Button
                    color="warning"
                    block
                    onClick={() => armar(-1)}
                    disabled={procesando || !selectedArea}
                  >
                    <i className="fas fa-undo"></i> Desarmar
                  </Button>
                </Col>
              </Row>

              <br />
              <Table size="sm" striped>
                <thead>
                  <tr>
                    <th>SKU</th>
                    <th>Componente</th>
                    <th style={{ textAlign: "right" }}>Piezas por kit</th>
                    <th style={{ textAlign: "right" }}>En inventario</th>
                    <th style={{ textAlign: "right" }}>Alcanza para</th>
                    <th style={{ textAlign: "right" }}>
                      Se descontará por {fmt(cant)} kits
                    </th>
                    {editarComponentes ? <th style={{ width: 60 }}></th> : null}
                  </tr>
                </thead>
                <tbody>
                  {componentes.length === 0 ? (
                    <tr>
                      <td colSpan="7" style={{ color: "#94a3b8" }}>
                        Este kit todavía no tiene componentes.
                      </td>
                    </tr>
                  ) : (
                    componentes.map((c) => {
                      const sku = c.componentes?.[0]?.SKU || "-";
                      // El backend calcula el disponible ya resuelto a master
                      const d = (disponible?.detalle || []).find(
                        (x) => x.SKU === sku
                      );
                      const limita = d?.limita && (disponible?.detalle || []).length > 1;
                      return (
                      <tr
                        key={c._id}
                        style={limita ? { background: "#fef3c7" } : undefined}
                      >
                        <td>
                          {sku}
                          {limita ? (
                            <span
                              title="Este componente pone el tope"
                              style={{
                                marginLeft: 6,
                                fontSize: "0.62rem",
                                fontWeight: 700,
                                color: "#92400e",
                                background: "#fde68a",
                                padding: "1px 5px",
                                borderRadius: 4,
                              }}
                            >
                              LIMITA
                            </span>
                          ) : null}
                        </td>
                        <td>{c.componentes?.[0]?.nombre || "-"}</td>
                        <td style={{ textAlign: "right" }}>
                          {fmt(c.cantidad)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {d ? fmt(d.disponible) : "-"}
                        </td>
                        <td style={{ textAlign: "right", fontWeight: 600 }}>
                          {d ? `${d.alcanzaPara} kits` : "-"}
                        </td>
                        <td
                          style={{
                            textAlign: "right",
                            fontWeight: 700,
                            color: "#dc2626",
                          }}
                        >
                          −{fmt(parseFloat(c.cantidad) * cant)}
                        </td>
                        {editarComponentes ? (
                          <td>
                            <Button
                              size="sm"
                              color="danger"
                              onClick={() => eliminarComponente(c._id)}
                            >
                              <i className="fas fa-minus"></i>
                            </Button>
                          </td>
                        ) : null}
                      </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>

              <small>
                <a
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    setEditarComponentes(!editarComponentes);
                  }}
                  style={{ color: "#64748b" }}
                >
                  {editarComponentes
                    ? "Ocultar edición de componentes"
                    : "Editar componentes de este kit"}
                </a>
              </small>

              {editarComponentes ? (
                <>
                  <br />
                  <br />
                  <Row>
                    <Col md={7}>
                      <Label>Componente</Label>
                      <Autocomplete
                        size="small"
                        value={nuevoComponente}
                        onChange={(event, sel) => setNuevoComponente(sel)}
                        options={opciones}
                        getOptionLabel={(option) => option.junta || ""}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Selecciona"
                            variant="outlined"
                          />
                        )}
                        renderOption={(option) => (
                          <React.Fragment>
                            {option.SKU} {option.nombre}
                          </React.Fragment>
                        )}
                      />
                    </Col>
                    <Col md={2}>
                      <Label>Piezas por kit</Label>
                      <Input
                        type="number"
                        min="0"
                        step="any"
                        value={nuevaCantidad}
                        onChange={(e) => setNuevaCantidad(e.target.value)}
                      />
                    </Col>
                    <Col md={3}>
                      <Label>&nbsp;</Label>
                      <Button color="info" block onClick={agregarComponente}>
                        <i className="fas fa-plus"></i> Agregar
                      </Button>
                    </Col>
                  </Row>
                </>
              ) : undefined}
            </>
          ) : undefined}

          <br />
          <Row>
            <Button color="danger" href="/MenuArticulos">
              Regresar
            </Button>
          </Row>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default ComponentesKit;
